import { Calendar as AntdCalendar } from "antd"
import { Tooltip } from "components/Tooltip/Tooltip"
import { Wrap } from "components/Wrap/Wrap"
import { ComponentProps } from "react"
import { cn } from "styles/cn"
import { formatDate } from "utils/date"

interface CalendarProps extends ComponentProps<typeof AntdCalendar> {
	tooltips?: Record<string, string>
}

export const Calendar = ({
	tooltips,
	className,
	value,
	fullscreen = false,
	headerRender = () => null,
	...props
}: CalendarProps) => (
	<AntdCalendar
		{...props}
		fullscreen={fullscreen}
		fullCellRender={defaultFullCellRender(tooltips)}
		headerRender={headerRender}
	/>
)

const defaultFullCellRender =
	(tooltips: CalendarProps["tooltips"]): CalendarProps["cellRender"] =>
	(current, info) => {
		const tooltip = tooltips?.[formatDate(current.toISOString())]
		const dayText = current.format("D")
		const isToday = current.isSame(info.today, "day")
		const isAfterToday = current.isAfter(info.today, "day")
		const isSameMonth = current.isSame(info.today, "month")

		return (
			<Wrap
				condition={!!tooltip}
				with={(children) => <Tooltip title={tooltip}>{children}</Tooltip>}
			>
				<div
					className={cn(
						"bg-navy-2/50 grid size-8 place-content-center justify-self-center rounded-full",
						!isSameMonth && "bg-navy-20/50",
						isSameMonth && "bg-navy-20",
						tooltip && "text-white",
						tooltip && isSameMonth && "bg-green-60",
						tooltip && !isSameMonth && "bg-green-60/50",
						(isToday || isAfterToday) && !tooltip && "bg-transparent",
					)}
				>
					{dayText}
				</div>
			</Wrap>
		)
	}
